import { FormRow } from '@ui';
import { FormInput } from 'components/Form/next';
import { Placeholder } from 'components/Form/next/FormWYSIWYG';
import { useTranslation } from 'react-i18next';
import { TemplateFields } from '../Template';

interface Props {
    withoutAddresses?: true | ('bcc' | 'cc' | 'to')[];
    placeholders?: Placeholder[];
}

export const MessageFields = ({ withoutAddresses, placeholders }: Props) => {
    const { t } = useTranslation('message-management');

    return (<>
        {withoutAddresses !== true && (
            <>
                {!withoutAddresses?.includes?.('to') && (
                    <FormInput
                        name="addresses"
                        options={{
                            setValueAs(value) {
                                return String(value).replaceAll(/\s/g, '').split(',');
                            }
                        }}
                        label={t('fields.to')}
                        helperText={t('fields.addressesHelperText')}
                    />
                )}
                <FormRow>
                    {!withoutAddresses?.includes?.('cc') && (
                        <FormInput
                            name="addresses_cc"
                            options={{
                                setValueAs(value) {
                                    return String(value).replaceAll(/\s/g, '').split(',');
                                }
                            }}
                            label={t('fields.cc')}
                            helperText={t('fields.addressesHelperText')}
                        />
                    )}
                    {!withoutAddresses?.includes?.('bcc') && (
                        <FormInput
                            name="addresses_bcc"
                            options={{
                                setValueAs(value) {
                                    return String(value).replaceAll(/\s/g, '').split(',');
                                }
                            }}
                            label={t('fields.bcc')}
                            helperText={t('fields.addressesHelperText')}
                        />
                    )}
                </FormRow>
            </>
        )}
        <FormInput name="subject" label={t('fields.subject')} />
        <FormInput.WYSIWYG name="message" label={t('fields.message')} placeholders={placeholders} />
        <FormInput.Files name="attachments" label={t('fields.attachments')} />
        <TemplateFields />
        <FormInput.Checkbox name="text_message" label={t('fields.textOnly')} />
    </>);
};
